/**
 * 支援技術への通知（FR-A11Y）。
 * ページ遷移などの状態変化は canvas ではなく DOM に現れる必要があるため、
 * aria-live 領域へ文言を書き込む。
 */
import { cls } from '../brand';

export class Announcer {
  private readonly el: HTMLDivElement;

  constructor(doc: Document) {
    this.el = doc.createElement('div');
    this.el.className = cls('sr-only');
    this.el.setAttribute('aria-live', 'polite');
    this.el.setAttribute('aria-atomic', 'true');
  }

  /** ビューワのルート直下へ設置する。 */
  mount(root: HTMLElement): void {
    root.appendChild(this.el);
  }

  /** 読み上げ内容を差し替える（同一文言でも読ませるため、一度空にする）。 */
  announce(message: string): void {
    this.el.textContent = '';
    this.el.textContent = message;
  }

  dispose(): void {
    this.el.remove();
  }
}
